import SpecialtiesModalContainer from './SpecialtiesModalContainer';

export default SpecialtiesModalContainer;
